import { EnemyObject } from '@phaser/objects/Enemy.object';
import { CardObject } from '@phaser/objects/Card.object';
import { DEPTH } from '@phaser/data/depth';
import { Game } from '@phaser/scenes/Game';

export class GameModeSystem {
  private _timeLeft = 0;
  private _enemiesLeft = 0;
  private _scene: Game = Game.current;

  private _timer?: Phaser.GameObjects.Text;
  private _count?: Phaser.GameObjects.Text;

  constructor() {}

  public destroy() {
    this._timer?.destroy();
    this._timer = undefined;

    this._count?.destroy();
    this._count = undefined;
  }

  public update(_time: number, delta: number) {
    this._updateTimer(delta);
  }

  public onCardDeath(card: CardObject) {
    if (!this._count) return;

    if (card instanceof EnemyObject) {
      this._enemiesLeft = Math.max(0, this._enemiesLeft - 1);
      this._count.setText(this._enemiesLeft.toString());
    }
  }

  public setSurvivalTimer(time: number) {
    if (!this._timer) this._showSurvival();
    this._timeLeft = time;
  }

  public setExterminateCount(count: number) {
    if (!this._count) this._showExterminate();
    this._enemiesLeft = count;
    this._count?.setText(this._enemiesLeft.toString());
  }

  private _showSurvival() {
    const camera = this._scene.cameras.main;
    const width = camera.displayWidth;

    this._timer = this._scene.add.text(width - 2, 0, '00:00', {
      fontFamily: 'Kode Mono Variable',
      fontSize: '14px',
      color: '#ffffff',
      resolution: 3,
    })
    .setOrigin(1, 0)
    .setDepth(DEPTH.MINIGAME);

    this._timeLeft = 1000 * 60 * 5;
    this._updateTimer(0);
  }

  private _showExterminate() {
    const camera = this._scene.cameras.main;
    const width = camera.displayWidth;

    this._count = this._scene.add.text(width - 2, 0, '0', {
      fontFamily: 'Kode Mono Variable',
      fontSize: '14px',
      color: '#ffffff',
      resolution: 3,
    })
    .setOrigin(1, 0)
    .setDepth(DEPTH.MINIGAME);
  }

  private _updateTimer(delta: number) {
    if (this._timeLeft <= 0 || !this._timer) return;
    this._timeLeft = Math.max(0, this._timeLeft - delta);

    const minutes = Math.floor(this._timeLeft / 1000 / 60);
    const seconds = Math.floor(this._timeLeft / 1000) % 60;

    const mm = minutes.toString().padStart(2, '0');
    const ss = seconds.toString().padStart(2, '0');

    this._timer?.setText(`${mm}:${ss}`);
  }
}